import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// tremor
import { Metric, Title as TremorTitle, Subtitle as TremorSubtitle, Bold, Italic, Text as TremorText } from "@tremor/react";

// utils 
import { Colors } from '../../../styles'

const TextText = (props) => {
    return (
        <p
            style={{
                marginTop: props.margin ? 0 : -10,
                color:'#737475',
                fontFamily:'Inter'         
            }}
        >{props.children}</p>
    );
};

const Title = (props) => {
    return (
        <p style={{
            color: Colors.PRM_LIGHT_BLUE,
            fontWeight:'bold',
            fontSize:12,
            fontFamily:'Inter'         
        }}>{props.children}</p>
    );
};

const Subtitle = (props) => {
    return (
        <p style={{
            fontWeight:'800',
            fontSize:28,
            marginTop:-18,
            fontFamily:'Inter'         
        }}>{props.children}</p>
    );
};

const Headline = (props) => {
    return (
        <p style={{
            fontWeight:'800',
            fontSize:22,
            fontFamily:'Inter'         
        }}>{props.children}</p>
    );
};

const Heading = (props) => {
    return (
        <p 
            style={{
                fontWeight:'bold', 
                fontSize:24, 
                color:props.color, 
                cursor:props.cursor,
                fontFamily:'Inter'         
            }}
            onClick={props.onClick}    
        >{props.children}</p>
    );
};

const Subheading = (props) => {
    return (
        <p 
            style={{
                fontWeight:'bold', 
                fontSize:18, 
                color:props.color, 
                cursor:props.cursor
            }}
            onClick={props.onClick}    
        >{props.children}</p>
    );
};

const Subsubheading = (props) => {
    return (
        <p 
            style={{
                fontWeight:'bold', 
                fontSize:14, 
                color:props.color, 
                cursor:props.cursor,
                fontFamily:'Inter'         
            }}
            onClick={props.onClick}    
        >{props.children}</p>
    );
};


const Header = (props) => {
    return (
        <div style={props.containerStyle} className={props.className}>
        <p 
            style={{
                fontWeight:'bold', 
                fontSize:14, 
                color:props.color, 
                cursor:props.cursor,
                fontFamily:'Inter'         
            }}
            onClick={props.onClick}    
        >{props.children}</p>
        </div>
    );
};

const Subheader = (props) => {
    return (
        <div style={props.containerStyle}>
        <p 
            style={{
                fontWeight:'400', 
                fontSize:14, 
                color:props.color, 
                cursor:props.cursor,
                fontFamily:'Inter'         
            }}
            onClick={props.onClick}    
        >{props.children}</p>
        </div>
    );
};

const TableHeader = (props) => {
    return (
        <p 
            style={{
                fontSize:14, 
                color:props.color, 
                cursor:props.cursor,
                fontFamily:'Mono',
                marginLeft: props.margin ? 22 : 0,
                fontWeight: props.bold ? '700' : '400', 
            }}
        >{props.children}</p>
    );
};

const TableBody = (props) => {
    return (
        <p 
            style={{
                fontWeight: props.bold ? '700' : '400', 
                fontSize:14, 
                color:props.color, 
                fontFamily:'Mono',
            }}
        >{props.children}</p>
    );
};

const TitleSubtitle = (props) => {
    return (
        <div>
            <Title>{props.title}</Title>
            <Subtitle>{props.subtitle}</Subtitle>
        </div>
    );
};

Text.Text = TextText;
Text.Title = Title;
Text.Subtitle = Subtitle;
Text.Header = Header;
Text.Heading = Heading;
Text.Subheading = Subheading;
Text.Subsubheading = Subsubheading;
Text.Subheader = Subheader;
Text.Headline = Headline;
Text.TitleSubtitle = TitleSubtitle;
Text.TableHeader = TableHeader;
Text.TableBody = TableBody;

export default Text;